
export enum PolygonTypeCd {
	AREA = 'Area',
	BOUNDARY = 'Boundary',
	FENCE = 'Fence',
	SERVICE_CENTER = 'ServiceCenter'}

